import { forunsStore } from '../../stores/forunsStore'

import React, { useEffect } from 'react'
import { Padding, DisplayFlex, Flex, styles } from '../../components/Styles'
import { Tabs, Tag, Button, Popover } from 'antd'
import { EditOutlined, WarningOutlined } from '@ant-design/icons'
import { format } from 'date-fns'
import styled from '@emotion/styled'
import { ForumMensagemModel } from '../../models/ForumMensagemModel'
import { Pagination } from '../../components/Pagination'
import { UsuarioModel } from '../../models/UsuarioModel'
import { filesUrl } from '../../index'
import * as _ from 'lodash'
import { Table } from 'antd'

// Helper function to safely format dates
const formatDate = (date: any, formatString: string = 'DD/MM/YYYY HH:mm') => {
  if (!date) return 'Data inválida'
  try {
    const parsedDate = new Date(date)
    if (isNaN(parsedDate.getTime())) return 'Data inválida'
    return format(parsedDate, formatString)
  } catch (error) {
    return 'Data inválida'
  }
}

export const ForunsView = () => {
  return (
    <forunsStore.Provider>
      <ForunsViewContent />
    </forunsStore.Provider>
  )
}

const ForunsViewContent = () => {
  const { mensagensPendentesCount } = forunsStore.useState()

  const tabItems = [
    {
      key: '1',
      label: 'Foruns',
      children: <ListaForuns />
    },
    {
      key: '2', 
      label: (
        <span>
          Pendente Moderação <Tag color="red">{mensagensPendentesCount}</Tag>
        </span>
      ),
      children: <PendentesModeracao />
    }
  ]

  return (
    <div>
      <Tabs 
        type="line"
        items={tabItems}
      />
      <ForumDetail />
    </div>
  )
}

const ListaForuns = () => {
  const dispatch = forunsStore.useDispatch()
  const { foruns, forunsCount, queryForuns } = forunsStore.useState()

  useEffect(() => {
    dispatch(forunsStore.thunks.getForuns())
    dispatch(forunsStore.thunks.getMensagensPendentes())
  }, [])

  const columns = [
    { title: 'Id', dataIndex: 'id', key: 'id' },
    { title: 'Titulo', dataIndex: 'titulo', key: 'titulo' },
    { 
      title: 'Qtd Respostas', 
      key: 'qtdRespostas',
      render: (_, forum) => (forum.forunsMensagens || []).length
    },
    { 
      title: 'Pendente Aprovação', 
      key: 'pendenteAprovacao',
      render: (_, forum) => forum.aguardandoModeracao ? <WarningOutlined style={{ color: 'orange' }} /> : ''
    },
  ]

  return (
    <React.Fragment>
      <Table
        columns={columns}
        dataSource={foruns}
        rowKey="id"
        onRow={(forum) => ({
          onClick: () => dispatch(forunsStore.thunks.setForum(forum.id)),
          style: { cursor: 'pointer' }
        })}
        pagination={false}
      />
      <Pagination
        onChangePage={(e) => dispatch(forunsStore.thunks.paginateForuns(e))}
        limit={queryForuns.limit}
        offset={queryForuns.offset}
        count={forunsCount}
      />
    </React.Fragment>
  )
}

const PendentesModeracao = () => {
  const dispatch = forunsStore.useDispatch()
  const {
    mensagensPendentes,
    mensagensPendentesCount,
    queryMensagensPendentes,
    selectedForumMensagem,
  } = forunsStore.useState()
  useEffect(() => {
    dispatch(forunsStore.thunks.getMensagensPendentes())
  }, [])

  useEffect(() => {
    if (selectedForumMensagem && selectedForumMensagem.id) {
      const ref = document.querySelector('.forum-mensagem-selected')
      if (ref) {
        ref.scrollIntoView()
      }
    }
  }, [selectedForumMensagem])

  const setForumMensagem = async (forumMensagem) => {
    await dispatch(forunsStore.thunks.setForumMensagem(forumMensagem))
  }

  const columns = [
    { title: 'Id', dataIndex: 'id', key: 'id' },
    { title: 'Texto', dataIndex: 'textoPendente', key: 'textoPendente' },
    { title: 'Enviado Por', dataIndex: ['usuario', 'nome'], key: 'enviadoPor' },
    { 
      title: 'Enviado Em', 
      dataIndex: 'createdAt', 
      key: 'enviadoEm',
      render: (createdAt) => formatDate(createdAt)
    },
  ]

  return (
    <>
      <Table
        columns={columns}
        dataSource={mensagensPendentes}
        rowKey="id"
        onRow={(forumMensagem) => ({
          onClick: async () => await setForumMensagem(forumMensagem),
          style: { cursor: 'pointer' }
        })}
        pagination={false}
      />
      <Pagination
        onChangePage={(e) => dispatch(forunsStore.thunks.paginateMensagensPendentes(e))}
        limit={queryMensagensPendentes.limit}
        offset={queryMensagensPendentes.offset}
        count={mensagensPendentesCount}
      />
    </>
  )
}

const ForumDetail = () => {
  const dispatch = forunsStore.useDispatch()
  const { forumActive, forumMensagemEditing, selectedForumMensagem } = forunsStore.useState()

  if (!forumActive || (forumActive && !forumActive.id)) return null
  return (
    <Padding>
      <DisplayFlex>
        <Flex>
          <h2>
            {forumActive.titulo}
            <br />
            <small>{formatDate(forumActive.createdAt)}</small>
          </h2>
        </Flex>
        <div>
          <Button onClick={() => dispatch(forunsStore.actions.forumActiveClean())}>Fechar</Button>
        </div>
      </DisplayFlex>
      <DisplayFlex>
        <Avatar usuario={forumActive.usuario} />
        <Mensagem>
          <div className="nome-usuario">
            <small>
              <b>{forumActive.usuario.nome}</b>
            </small>
            <br />
          </div>
          <div className="textos">{forumActive.texto}</div>
        </Mensagem>
      </DisplayFlex>
      <DisplayFlex>
        <Flex></Flex>
        <Button onClick={() => dispatch(forunsStore.thunks.aprovarForum())}>Aprovar Fórum</Button>
      </DisplayFlex>
      <div>
        <ForunsMensagens forunsMensagens={forumActive.forunsMensagens} />
      </div>
      {!_.get(forumMensagemEditing, 'id', false) &&
        !_.get(forumMensagemEditing, 'forumMensagemId', false) && (
          <div>
            <div style={{ marginTop: '18px' }}>
              <strong>Enviar Resposta</strong>
            </div>
            <EnviarResposta />
          </div>
        )}
    </Padding>
  )
}

const ForunsMensagens = ({ forunsMensagens }: { forunsMensagens: ForumMensagemModel[] }): any => {
  const dispatch = forunsStore.useDispatch()
  const { forumMensagemEditing, selectedForumMensagem } = forunsStore.useState()

  return (forunsMensagens || []).map((forumMensagem) => (
    <ContainerForunsMensagens key={forumMensagem.id} hasParent={!!forumMensagem.forumMensagemId}>
      {/* <div className="indicador-vertical"></div> */}
      <Flex>
        <div>
          <ContainerMensagem>
            <Avatar usuario={forumMensagem.usuario} />
            <Mensagem>
              <div className="nome-usuario">
                <small>
                  <b>{forumMensagem.usuario.nome}</b> -{' '}
                  {formatDate(forumMensagem.createdAt)}
                </small>
                <br />
              </div>

              <div className="textos">
                {!!forumMensagem.texto && (
                  <div>
                    {forumMensagemEditing.id === forumMensagem.id ? (
                      <EnviarResposta forumMensagemId={forumMensagem.id} />
                    ) : (
                      <React.Fragment>
                        <EditOutlined
                          onClick={() => {
                            dispatch(forunsStore.actions.setEditaForumMensagem({ forumMensagem }))
                          }}
                          style={{ cursor: 'pointer', marginRight: 8 }}
                        />
                        {forumMensagem.texto}
                      </React.Fragment>
                    )}
                  </div>
                )}

                {!!forumMensagem.textoPendente && (
                  <DisplayFlex marginBetween={8}>
                    <TextoPendente
                      selected={
                        selectedForumMensagem && selectedForumMensagem.id === forumMensagem.id
                      }
                      className={
                        selectedForumMensagem && selectedForumMensagem.id === forumMensagem.id
                          ? 'forum-mensagem-selected'
                          : ''
                      }
                    >
                      {forumMensagem.textoPendente}
                    </TextoPendente>
                    <Button
                      onClick={() => dispatch(forunsStore.thunks.aprovarMensagem(forumMensagem))}
                    >
                      Aprovar
                    </Button>
                    <Popover
                      content="O usuário será informado que a mensagem foi rejeitada"
                    >
                      <Button
                        onClick={() =>
                          dispatch(forunsStore.thunks.rejeitarMensagem(forumMensagem))
                        }
                      >
                        Rejeitar
                      </Button>
                    </Popover>
                  </DisplayFlex>
                )}
              </div>
            </Mensagem>
          </ContainerMensagem>
          {!!forumMensagem.forunsMensagens && !!forumMensagem.forunsMensagens.length && (
            <Respostas>
              <ForunsMensagens forunsMensagens={forumMensagem.forunsMensagens} />
            </Respostas>
          )}
        </div>
        {!forumMensagem.forumMensagemId && (
          <EnviarRespostaContainer forumMensagem={forumMensagem} />
        )}
        {/* {!forumMensagem.forumMensagemId && <div className="indicador-horizontal"></div>} */}
      </Flex>
    </ContainerForunsMensagens>
  ))
}

const EnviarRespostaContainer = React.memo(
  ({ forumMensagem }: { forumMensagem?: ForumMensagemModel }) => {
    const dispatch = forunsStore.useDispatch()
    const { forumMensagemEditing } = forunsStore.useState()

    if (forumMensagem.id === forumMensagemEditing.forumMensagemId && !forumMensagemEditing.id) {
      return (
        <div style={{ width: 'calc(100% - 46px)', marginLeft: '43px' }}>
          <EnviarResposta forumMensagemId={forumMensagem.id} />
        </div>
      )
    }

    return (
      <div style={{ textAlign: 'right' }}>
        <Popover content="Enviar Resposta">
          <Button
            icon={<EditOutlined />}
            onClick={() => {
              const forumMensagemResposta = new ForumMensagemModel()
              forumMensagemResposta.forumMensagemId = forumMensagem.id
              dispatch(
                forunsStore.actions.setEditaForumMensagem({
                  forumMensagem: forumMensagemResposta,
                })
              )
            }}
          />
        </Popover>
      </div>
    )
  }
)

const EnviarResposta = React.memo(({ forumMensagemId }: { forumMensagemId?: number }) => {
  const dispatch = forunsStore.useDispatch()
  const { forumMensagemEditing } = forunsStore.useState()
  
  const cancelarMensagemResposta = () => {
    dispatch(forunsStore.actions.setEditaForumMensagem({ forumMensagem: null }))
  }
  return (
    <React.Fragment>
      <textarea
        rows={3}
        onChange={(e) =>
          dispatch(forunsStore.actions.setMensagemResposta({ texto: e.target.value }))
        }
        value={forumMensagemEditing.texto || ''}
        style={{ width: '100%' }}
      />
      <DisplayFlex marginBetween={8}>
        <Flex />
        <Button onClick={() => dispatch(forunsStore.thunks.enviarMensagemResposta())}>
          Enviar
        </Button>
        {!!forumMensagemId && <Button onClick={cancelarMensagemResposta}>Cancelar</Button>}
      </DisplayFlex>
    </React.Fragment>
  )
})

const Avatar = React.memo(({ usuario }: { usuario: UsuarioModel }) => {
  function hashCode(str: any) {
    // java String#hashCode
    let hash = 0
    for (let i = 0; i < str.length; i++) {
      hash = str.charCodeAt(i) + ((hash << 5) - hash)
    }
    return hash
  }

  function intToRGB(i: any) {
    const c = (i & 0x00ffffff).toString(16).toUpperCase()

    return '#' + ('00000'.substring(0, 6 - c.length) + c)
  }

  function getIniciais(nome: string) {
    return nome
      .split(' ')
      .filter((x) => !'do,da,dos,das'.includes(x))
      .map((x) => x.slice(0, 1))
      .join('')
  }

  if (usuario.avatar) return <AvatarContainerImg src={`${filesUrl}/${usuario.avatar}`} />

  const iniciais = getIniciais(usuario.nome)

  return (
    <AvatarContainerDiv bgColor={intToRGB(hashCode(usuario.nome))}>{iniciais}</AvatarContainerDiv>
  )
})

const AvatarContainerImg = styled('img')`
  width: 32px;
  height: 32px;
  border-radius: 50%;
  display: inline-block;
`
const AvatarContainerDiv = styled('div')`
  width: 32px;
  height: 32px;
  border-radius: 50%;
  display: inline-block;
  background-color: ${(props: { bgColor?: string }) => (props.bgColor ? props.bgColor : '')};
  color: white;
  text-shadow: ${styles.textShadow};
  display: flex;
  align-items: center;
  justify-content: center;
`

const TextoPendente = styled('div')((props: { selected?: boolean }) => ({
  background: '#dedede',
  padding: '6px 12px',
  borderRadius: '6px',
  flex: 1,
  borderLeft: props.selected ? '4px solid red' : '',
}))

// border: 1px solid #ccc;
const Respostas = styled('div')`
  padding: 12px 12px 12px 37px;
`

const ContainerForunsMensagens = styled('div')<{ hasParent }>`
  display: flex;
  border-left: 2px solid #ccc;
  ${(props: any) =>
    !props.hasParent
      ? `
  border-bottom: 2px solid #ccc;
  padding-bottom: 12px;
  `
      : ''}
  margin-left: 19px;
`
// .indicador-vertical {
//   width: 2px;
//   background: #dedede;
//   display: block;
//   position: relative;
//   left: 20px;
//   z-index: -1;
//   top 19px;
// }
// .indicador-horizontal {
//   height: 2px;
//   background: #dedede;
//   position: relative;
//   top: -18px;
//   z-index: -1;
//   width: calc(100% - 34px);
//   left: 18px;
// }

// border: 1px solid red;
const ContainerMensagem = styled('div')`
  padding: 3px;
  display: flex;
  position: relative;
  left: -20px;
`

const Mensagem = styled('div')`
  border: 1px solid #ccc;
  border-radius: 6px;
  flex: 1;
  margin-left: 8px;
  .nome-usuario {
    background: #dedede;
    padding: 4px;
  }
  .textos {
    padding: 6px;
  }
`
// .container-inner {
//   margin-right: 8px;
//   display: flex;
//   &:before {
//     width: 2px;
//     background: #dadada;
//     height: calc(100% + 51px);
//     content: ' ';
//     display: inline-table;
//     position: relative;
//     left: -18px;
//     z-index: -1;
//   }
//   .container-avatar-mensagens {
//     display: flex;
//   }

//   .container-mensagens {
//     margin-left: 10px;
//     border: 1px solid #ccc;
//     border-radius: 4px;
//     flex: 1;
//     ${(props: any) => !props.hasParent ? `&:after {
//       height: 2px;
//       content: ' ';
//       display: block;
//       width: calc(100% + 10px);
//       background: gainsboro;
//       position: relative;
//       top: 19px;
//       left: -30px;
//     }` : ``}

//     .container-nome-usuario {
//       background: #dedede;
//       padding: 4px;
//     }

//     .container-textos {
//       padding: 6px;
//       &>*:not(:last-child) {
//       }
//     }
//   }
// }
